export default __webpack_public_path__ + "3c0cae04e29ee7cbd8135164d51cea4f.svg";